import React from "react";

import { Avatar, Button, makeStyles, Typography } from "@material-ui/core";
import { MdKeyboardArrowRight } from "react-icons/md";

import { getDomain } from "modules/core/utils/helpers";

import { IUser } from "modules/user/types/entities";

interface ISelectAccountProps {
  accounts: IUser["accounts"];
  onSelect: (subdomain: string) => void;
}

const useStyles = makeStyles(theme => ({
  list: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: 10,
    width: "100%"
  },

  btn: {
    justifyContent: "space-between",
    height: 60,
    border: `1px solid ${theme.palette.grey[400]}`,
    padding: "0 25px",
    width: "100%"
  },

  btnRow: {
    display: "flex",
    alignItems: "center",
    gap: 10
  }
}));

const domain = getDomain();

const SelectAccount: React.FC<ISelectAccountProps> = props => {
  const { accounts, onSelect } = props;

  const classes = useStyles();

  return (
    <div className={classes.list}>
      {accounts.map(account => {
        const url = account.subdomain + "." + domain;

        return (
          <Button
            key={account.subdomain}
            size="large"
            variant="text"
            onClick={() => onSelect(account.subdomain)}
            className={classes.btn}
            disableElevation
          >
            <span className={classes.btnRow}>
              <Avatar component="span" src={account.logo ?? undefined}>
                {account.name?.at(0)}
              </Avatar>

              <span style={{ textAlign: "left", lineHeight: 1 }}>
                <Typography
                  component="span"
                  variant="subtitle2"
                  style={{ display: "block", lineHeight: 1 }}
                >
                  {account.name}
                </Typography>

                <Typography
                  component="span"
                  variant="caption"
                  color="textSecondary"
                  style={{ textTransform: "none" }}
                >
                  {url}
                </Typography>
              </span>
            </span>

            <MdKeyboardArrowRight size={26} />
          </Button>
        );
      })}
    </div>
  );
};

export default React.memo(SelectAccount);
